module.exports = __webpack_public_path__ + "img/montre_on.2ef11c35.gif";